import { device } from './utils';
import './vendor/jquery.nice-select';
import './utils/localstorage';
// import { createToggleButton } from 'platform-common-util/dist/dark-mode';

(function(window, $) {
  $(function() {
    // device check!
    // let deviceType = device.ios ? 'ios' : device.android ? 'android' : 'pc';
    let deviceType;
    if (device.ios) {
      deviceType = 'ios';
    } else if (device.android) {
      deviceType = 'android';
    } else if (device.nintendoBrowser) {
      deviceType = 'nintendo';
    } else {
      deviceType = 'pc';
    }

    if (deviceType === 'ios') {
      const standalone = window.navigator.standalone;
      const userAgent = window.navigator.userAgent.toLowerCase();
      const safari = /safari/.test(userAgent);

      if (!standalone && safari) {
        // browser
      } else if (standalone && !safari) {
        // standalone
      } else if (!standalone && !safari) {
        // uiwebview
        deviceType = 'ios-webview';

        // TEST
        // let dom = $('<div><h2>::: iOS WebView :::</h2></div>');
        // dom.css({
        //   position: 'fixed',
        //   zIndex: 99999999,
        //   top: 100,
        //   left: 50,
        //   background: 'red',
        //   color: 'white',
        // });
        // $('body').append(dom);
      }
    }
    $('body').attr('device', deviceType);

    // custom dropdown
    if (deviceType === 'pc' || deviceType !== 'nintendo') {
      $('select:not(.ignore)').niceSelect();
    }

    $('#go-print').on('click', function() {
      window.print();
    });

    // 다크테마 토글 버튼
    // createToggleButton();

    const layoutValue = sessionStorage.getItem('layout');

    if (layoutValue === 'content' || device.purple) {
      document.body.setAttribute('data-view', 'content');

      ['#nc-cnb', '#footer'].forEach(elementId => {
        const element = document.querySelector(elementId);
        if (element) {
          element.remove();
        }
      });

      const contentsElements = document.querySelectorAll('.contents');
      contentsElements.forEach(element => {
        element.style.padding = '0';
      });

      // darkmode fix
      window.NPlatformUtil.darkMode.update({ mode: 'dark', disableToggle: true, cookieName: '' });

      // scrollbar style
      // document.querySelector('html').setAttribute('data-user-client', 'NGPClient');
    }
  });
  // eslint-disable-next-line no-undef
})(window, $);
